const TABLE_HEAD = [
  { id: 'tracking', label: 'Tracking', width: 380 },
  { id: 'status', label: 'Status', width: 100 },
  { id: '', width: 100 },
];

const defaultFilters = {
  name: '',
  role: [],
};
const tableNames = [
  { id: 'tracking', label: 'Tracking' },
  { id: 'status', label: 'Status' },
];

const status = ['ACTIVE', 'INACTIVE'];

const personalInformation = [
  {
    name: 'tracking',
    width: '100%',
    label: 'Tracking',
  },
];

const status_colors = {
  ACTIVE: ['#22C55E29', '#118D57'],
  INACTIVE: ['#919EAB29', '#637381'],
};

export { TABLE_HEAD, defaultFilters, tableNames, status, personalInformation, status_colors };
